import React from "react";
import HTMLFlipBook from "react-pageflip";
import "./Booklet.css"; // for custom styles
import Testimonials from "./Testimonials";

const images = [
  "/images/boisson.jpeg",
  "/images/menu (1).jpeg",
  "/images/menu (2).jpeg",
  "/images/menu (3).jpeg",
  "/images/menu (4).jpeg",
];

const Booklet = () => {
  return (
    <div className="hero">
      <div className="menu-container">
        <div className="menu-announcement">
          <h1 className="menu-title">LES MENUS</h1>
          <p className="changing-menu-text">
            Les menus changent chaque jours - Suivez moi sur les réseaux
          </p>
          <div className="social-media-links">
            <div className="contact-links mt-4">
              <a
                href="https://wa.me/41794180115"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-button whatsapp"
              >
                <img src="/images/whatsapp.png" alt="WhatsApp" />
                WhatsApp
              </a>

              <a
                href="https://www.instagram.com/ebeeny_meal"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-button instagram"
              >
                <img src="/images/instagram-icon.png" alt="Instagram" />
                Instagram
              </a>
            </div>
          </div>
        </div>
        <div className="menu-content">
          <div className="booklet-container">
            <HTMLFlipBook
              width={290}
              height={400}
              size="stretch"
              minWidth={315}
              maxWidth={100}
              minHeight={400}
              maxHeight={1536}
              maxShadowOpacity={0.5}
              showCover={true}
              mobileScrollSupport={true}
              className="book"
            >
              {images.map((src, index) => (
                <div className="page" key={index}>
                  <img src={src} alt={`Page ${index + 1}`} />
                </div>
              ))}
            </HTMLFlipBook>
          </div>

          {/* Row 7: Bon Appetit */}
          <div className="bon-appetit">Bon appétit!</div>
        </div>

        <div className="testimonials">
          <h2 className="testimonials-title">
            Ils ont goutés, voici leur avis
          </h2>
          <Testimonials />
        </div>
      </div>
      {/*Footer*/}
      <footer className="footer">
        <div className="footer-content">
          <h4>Ebeeny Meal</h4>
          <p>Lausanne / Vaud - Saveurs africaines & caribéennes</p>
          <p className="copyright">
            © {new Date().getFullYear()} Ebeeny Meal. Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Booklet;
